var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Collapse from 'bootstrap/js/dist/collapse';
export class Accordion extends Component {
    constructor(isDebugEnabled = false) {
        super('Accordion', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-toggle-all').on('click', (event, button) => {
                event.preventDefault();
                const accordion = button.parents('.accordion');
                let areAllExpanded = true;
                accordion.find('.collapse').each((collapse) => {
                    if (!collapse.hasClass('show'))
                        areAllExpanded = false;
                });
                accordion.find('.collapse').each((collapse) => {
                    const bs_collapse = new BS_Collapse(collapse.get(0), { toggle: false });
                    if (areAllExpanded) {
                        bs_collapse.hide();
                    }
                    else {
                        bs_collapse.show();
                    }
                });
                if (areAllExpanded) {
                    button.attr('aria-expanded', 'false');
                }
                else {
                    button.attr('aria-expanded', 'true');
                }
            });
            $('.collapse').on('show.bs.collapse', (event, collapse) => __awaiter(this, void 0, void 0, function* () {
                if (collapse.data('content') == '' || collapse.html().length > 0)
                    return;
                collapse.empty().append($.parseHTML('<div></div><div class="d-flex justify-content-center my-32"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>'));
                const response = yield $.httpRequest({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    body: {
                        'action': 'load_collapsible_content',
                        'content': collapse.data('content'),
                        'id': collapse.data('id')
                    },
                    dataType: 'html'
                });
                collapse.empty().append(response);
            }));
            this.success();
        });
    }
}
